import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  patchTransportSedel,
  TransportSedelQueryKey,
} from "api/transportSedel.api";
import { UppdragQueryKey } from "api/uppdrag.api";
import { useNotification } from "hooks/useNotification";
import { useState } from "react";

// Delad bas för operatörens fokuserade ett-fälts-sheets: modal-state +
// patch-mutation som stänger sheeten och invaliderar queries vid succé.
export const usePatchTransportSedelSheet = () => {
  const queryClient = useQueryClient();
  const notification = useNotification();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const mutation = useMutation({
    ...patchTransportSedel(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetOne] });
      queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetList] });
      queryClient.invalidateQueries({
        queryKey: [TransportSedelQueryKey.GetList],
      });
      setIsModalOpen(false);
    },
    onError: () => notification.error(),
  });

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    onModalClose: () => setIsModalOpen(false),
    mutation,
  };
};
